import { useUser } from '@paintscout/ui-business'
import { removeAuth0Prefix } from '@paintscout/util'
import type { CalendarEvent } from 'paintscout'
import { useMemo } from 'react'

export const useProductionEventPermissions = (event: CalendarEvent | null | undefined) => {
  const { hasPermissions, user, isOfficeUser, isAdmin, isSuperadmin, isSupport, isCorporate } = useUser()
  const isPrivileged = isAdmin || isSuperadmin || isSupport || isCorporate

  const currentUserId = removeAuth0Prefix(user?.user_id)
  const isOwner = !!event?.estimator?.id && removeAuth0Prefix(event.estimator.id) === currentUserId

  // assigned users are derived from assigned users on the deal + the deal's owner
  const assignedUsers = event?.assignedUsers
  const isAssigned = Array.isArray(assignedUsers)
    ? assignedUsers.some((id) => removeAuth0Prefix(id) === currentUserId)
    : !!assignedUsers &&
      Object.entries(assignedUsers).some(([id, v]) => removeAuth0Prefix(id) === currentUserId && v.assigned)

  const permissionToViewDetails =
    isOfficeUser || isOwner || isAssigned || isPrivileged || hasPermissions(['read:all-events'])

  const permissionToEdit = isOfficeUser || isOwner || isAssigned || isPrivileged || hasPermissions(['write:all-events'])

  return useMemo(
    () => ({ permissionToViewDetails, permissionToEdit }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [event, user, hasPermissions, isOfficeUser, isPrivileged, isOwner, isAssigned]
  )
}
